import {
  generateGenerateEditActions,
  generateItemsReducer,
  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
} from "./item";

const itemType = "version";
const endpoint = "versions/";

export const versionsReducer = generateItemsReducer<VersionSnakeModel, VersionLocalData>(itemType);

export const versionAndActionsFromStore = generateItemAndActionsFromStore<VersionSnakeModel, VersionLocalData, ItemEditActions<SectionNode>>(
  itemType,
  endpoint,
  generateGenerateEditActions<VersionSnakeModel, VersionLocalData, SectionNode>(
    (version) => version._editData.json || ("lastSyncedAt" in version && version.json) || undefined,
    (content) => ({json: content}),
  ),
);

export const versionListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, versionAndActionsFromStore);
